export const GENERIC_ERROR_MESSAGE =
  'Algo inesperado aconteceu, favor tentar novamente ou contactar o suporte!'

export class ApiError extends Error {
  readonly status: number
  readonly erros: string[]

  constructor(message: string, status: number, erros: string[] = []) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.erros = erros
  }

  get isValidation(): boolean {
    return this.status === 400 || this.status === 422
  }
}

export class UnauthorizedError extends ApiError {
  constructor(message = 'Sua sessão expirou, entre novamente.') {
    super(message, 401)
    this.name = 'UnauthorizedError'
  }
}

export class ForbiddenError extends ApiError {
  constructor(message = 'Você não tem permissão para executar esta ação.') {
    super(message, 403)
    this.name = 'ForbiddenError'
  }
}

export class NetworkError extends ApiError {
  constructor(message = 'Sem conexão com o servidor, verifique sua internet.') {
    super(message, 0)
    this.name = 'NetworkError'
  }
}

export const toErrorMessage = (error: unknown): string => {
  if (error instanceof ApiError) return error.message
  if (error instanceof Error && error.message) return error.message
  return GENERIC_ERROR_MESSAGE
}

export const errorMessageFor = (acao: string): string =>
  `Erro ao ${acao}, favor tentar novamente ou contactar o suporte!`
